import { FC } from 'react';

import BannerPreviewDescription from 'components/Banner/Preview/BannerPreviewDescription';
import BannerPreviewImage from 'components/Banner/Preview/BannerPreviewImage';

import { FrontendStatusType } from 'store/models/dashboard';

import styles from 'components/Banner/Preview/Preview.module.less';

interface Preview {
    campaignId: number;
    imageUrl: string;
    bannerId: number;
    title: string;
    vacancyId: number | null;
    text: string;
    frontendStatus: FrontendStatusType;
    hasVideo: boolean;
    url: string;
    isCampaignArchived: boolean;
    isReadOnlyAccount: boolean;
    isInformationCampaign: boolean;
}

const Preview: FC<Preview> = ({
    campaignId,
    imageUrl,
    bannerId,
    title,
    text,
    vacancyId,
    hasVideo,
    url,
    isCampaignArchived,
    isReadOnlyAccount,
    isInformationCampaign,
}) => {
    const bannerAction = `/new/campaign/${campaignId}/banner/${bannerId}/`;

    return (
        <div className={styles.bannerPreview} data-qa="ad-block__banner-title">
            <BannerPreviewImage
                bannerAction={bannerAction}
                imageUrl={imageUrl}
                isCampaignArchived={isCampaignArchived}
                isReadOnlyAccount={isReadOnlyAccount}
                hasVideo={hasVideo}
                isInformationCampaign={isInformationCampaign}
            />
            <BannerPreviewDescription
                bannerAction={bannerAction}
                campaignId={campaignId}
                bannerId={bannerId}
                isCampaignArchived={isCampaignArchived}
                isReadOnlyAccount={isReadOnlyAccount}
                text={text}
                title={title}
                vacancyId={vacancyId}
                url={url}
                isInformationCampaign={isInformationCampaign}
            />
        </div>
    );
};

export default Preview;
